<template>
    <v-container
        fluid
        class="sidebar-content"
    >
        <h3 class="pb-4">
            {{ $t("sidebar.elementList") }}
        </h3>
        <v-list class="props-list general-list">
            <v-list-item
                v-for="(item, index) in data.documents"
                :key="`document-${index}`"
                class="pb-2 pl-4"
            >
                <a
                    href="#"
                    @click.prevent="setDocument(index)"
                    :class="{'active': item.active}"
                >
                    {{ item.name }}
                </a>
            </v-list-item>
        </v-list>
    </v-container>
</template>

<script>
    import { EventBus } from '@/event-bus';
    export default {
        name: 'DocumentationSidebar',
        props: [
            'data',
            'handler'
        ],
        mounted() {
            this.handler();
        },
        methods: {
            setDocument(index) {
                if (this.$vuetify.breakpoint.smAndDown) {
                    EventBus.$emit('closeSidebar');
                    this.loadDocument(index);
                } else
                    this.loadDocument(index);
            },
            loadDocument(index) {
                let localData = _.cloneDeep(this.data);
                localData.documents.filter(el => el.active).forEach(el => el.active = false);
                localData.documents[index].active = true;
                let activeDocument = localData.documents.filter((document) => document.active === true)[0];
                EventBus.$emit('updateSidebar', localData, false);
                EventBus.$emit('updateDocumentSource', activeDocument.link);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/sidebar/DocumentationSidebar.vue